const prefixes = ['', '-webkit-', '-moz-', '-o-', '-ms-', ''];
const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
export const isTouchDevice = (): boolean => {
  const DocumentTouch = (<any>window).DocumentTouch;
  if ('ontouchstart' in window || (DocumentTouch && document instanceof DocumentTouch)) {
    return true;
  }
  return (<any>window).matchMedia(query).matches;
};
